/*!
 * pickadate.js v3.5.6, 2015/04/20
 * By Amsul, http://amsul.ca
 * Hosted on http://amsul.github.io/pickadate.js
 * Licensed under MIT
 */
!(function(a) {
    'function' == typeof define && define.amd
        ? define('picker', ['jquery'], a)
        : 'object' == typeof exports
        ? (module.exports = a(require('jquery')))
        : (this.Picker = a(jQuery));
})(function(a) {
    function b(f, g, i, m) {
        function n() {
            return b._.node(
                'div',
                b._.node(
                    'div',
                    b._.node(
                        'div',
                        b._.node('div', B.component.nodes(w.open), y.box),
                        y.wrap
                    ),
                    y.frame
                ),
                y.holder,
                'tabindex="-1"'
            );
        }
        function o() {
            z
                .data(g, B)
                .addClass(y.input)
                .val(z.data('value') ? B.get('select', x.format) : f.value),
                x.editable ||
                    z
                        .on('focus.' + w.id + ' click.' + w.id, function(a) {
                            a.preventDefault(), B.open();
                        })
                        .on('keydown.' + w.id, u),
                e(f, {
                    haspopup: !0,
                    expanded: !1,
                    readonly: !1,
                    owns: f.id + '_root'
                });
        }
        function p() {
            e(B.$root[0], 'hidden', !0);
        }
        function q() {
            B.$holder
                .on({
                    keydown: u,
                    'focus.toOpen': t,
                    blur: function() {
                        z.removeClass(y.target);
                    },
                    focusin: function(a) {
                        B.$root.removeClass(y.focused), a.stopPropagation();
                    },
                    'mousedown click': function(b) {
                        var c = b.target;
                        c != B.$holder[0] &&
                            (b.stopPropagation(),
                            'mousedown' != b.type ||
                                a(c).is(
                                    'input, select, textarea, button, option'
                                ) ||
                                (b.preventDefault(), B.$holder[0].focus()));
                    }
                })
                .on(
                    'click',
                    '[data-pick], [data-nav], [data-clear], [data-close]',
                    function() {
                        var b = a(this),
                            c = b.data(),
                            d =
                                b.hasClass(y.navDisabled) ||
                                b.hasClass(y.disabled),
                            e = h();
                        (e = e && (e.type || e.href)),
                            (d || (e && !a.contains(B.$root[0], e))) &&
                                B.$holder[0].focus(),
                            !d && c.nav
                                ? B.set(
                                      'highlight',
                                      B.component.item.highlight,
                                      { nav: c.nav }
                                  )
                                : !d && 'pick' in c
                                ? (B.set('select', c.pick),
                                  x.closeOnSelect && B.close(!0))
                                : c.clear
                                ? (B.clear(), x.closeOnClear && B.close(!0))
                                : c.close && B.close(!0);
                    }
                );
        }
        function r() {
            var b;
            x.hiddenName === !0
                ? ((b = f.name), (f.name = ''))
                : ((b = [
                      'string' == typeof x.hiddenPrefix ? x.hiddenPrefix : '',
                      'string' == typeof x.hiddenSuffix
                          ? x.hiddenSuffix
                          : '_submit'
                  ]),
                  (b = b[0] + f.name + b[1])),
                (B._hidden = a(
                    '<input type=hidden name="' +
                        b +
                        '"' +
                        (z.data('value') || f.value
                            ? ' value="' + B.get('select', x.formatSubmit) + '"'
                            : '') +
                        '>'
                )[0]),
                z.on('change.' + w.id, function() {
                    B._hidden.value = f.value
                        ? B.get('select', x.formatSubmit)
                        : '';
                });
        }
        function s() {
            v && l
                ? B.$holder
                      .find('.' + y.frame)
                      .one('transitionend', function() {
                          B.$holder[0].focus();
                      })
                : B.$holder[0].focus();
        }
        function t(a) {
            a.stopPropagation(),
                z.addClass(y.target),
                B.$root.addClass(y.focused),
                B.open();
        }
        function u(a) {
            var b = a.keyCode,
                c = /^(8|46)$/.test(b);
            return 27 == b
                ? (B.close(!0), !1)
                : void (
                      (32 == b || c || (!w.open && B.component.key[b])) &&
                      (a.preventDefault(),
                      a.stopPropagation(),
                      c ? B.clear().close() : B.open())
                  );
        }
        if (!f) return b;
        var v = !1,
            w = { id: f.id || 'P' + Math.abs(~~(Math.random() * new Date())) },
            x = i ? a.extend(!0, {}, i.defaults, m) : m || {},
            y = a.extend({}, b.klasses(), x.klass),
            z = a(f),
            A = function() {
                return this.start();
            },
            B = (A.prototype = {
                constructor: A,
                $node: z,
                start: function() {
                    return w && w.start
                        ? B
                        : ((w.methods = {}),
                          (w.start = !0),
                          (w.open = !1),
                          (w.type = f.type),
                          (f.autofocus = f == h()),
                          (f.readOnly = !x.editable),
                          (f.id = f.id || w.id),
                          'text' != f.type && (f.type = 'text'),
                          (B.component = new i(B, x)),
                          (B.$root = a(
                              '<div class="' +
                                  y.picker +
                                  '" id="' +
                                  f.id +
                                  '_root" />'
                          )),
                          p(),
                          (B.$holder = a(n()).appendTo(B.$root)),
                          q(),
                          x.formatSubmit && r(),
                          o(),
                          x.containerHidden
                              ? a(x.containerHidden).append(B._hidden)
                              : z.after(B._hidden),
                          x.container
                              ? a(x.container).append(B.$root)
                              : z.after(B.$root),
                          B.on({
                              start: B.component.onStart,
                              render: B.component.onRender,
                              stop: B.component.onStop,
                              open: B.component.onOpen,
                              close: B.component.onClose,
                              set: B.component.onSet
                          }).on({
                              start: x.onStart,
                              render: x.onRender,
                              stop: x.onStop,
                              open: x.onOpen,
                              close: x.onClose,
                              set: x.onSet
                          }),
                          (v = c(B.$holder[0])),
                          f.autofocus && B.open(),
                          B.trigger('start').trigger('render'));
                },
                render: function(b) {
                    return (
                        b
                            ? ((B.$holder = a(n())),
                              q(),
                              B.$root.html(B.$holder))
                            : B.$root
                                  .find('.' + y.box)
                                  .html(B.component.nodes(w.open)),
                        B.trigger('render')
                    );
                },
                stop: function() {
                    return w.start
                        ? (B.close(),
                          B._hidden &&
                              B._hidden.parentNode.removeChild(B._hidden),
                          B.$root.remove(),
                          z.removeClass(y.input).removeData(g),
                          setTimeout(function() {
                              z.off('.' + w.id);
                          }, 0),
                          (f.type = w.type),
                          (f.readOnly = !1),
                          B.trigger('stop'),
                          (w.methods = {}),
                          (w.start = !1),
                          B)
                        : B;
                },
                open: function(c) {
                    return w.open
                        ? B
                        : (z.addClass(y.active),
                          e(f, 'expanded', !0),
                          setTimeout(function() {
                              B.$root.addClass(y.opened),
                                  e(B.$root[0], 'hidden', !1);
                          }, 0),
                          c !== !1 &&
                              ((w.open = !0),
                              v &&
                                  k
                                      .css('overflow', 'hidden')
                                      .css('padding-right', '+=' + d()),
                              s(),
                              j
                                  .on(
                                      'click.' + w.id + ' focusin.' + w.id,
                                      function(a) {
                                          var b = a.target;
                                          b != f &&
                                              b != document &&
                                              3 != a.which &&
                                              B.close(b === B.$holder[0]);
                                      }
                                  )
                                  .on('keydown.' + w.id, function(c) {
                                      var d = c.keyCode,
                                          e = B.component.key[d],
                                          f = c.target;
                                      27 == d
                                          ? B.close(!0)
                                          : f != B.$holder[0] || (!e && 13 != d)
                                          ? a.contains(B.$root[0], f) &&
                                            13 == d &&
                                            (c.preventDefault(), f.click())
                                          : (c.preventDefault(),
                                            e
                                                ? b._.trigger(
                                                      B.component.key.go,
                                                      B,
                                                      [b._.trigger(e)]
                                                  )
                                                : B.$root
                                                      .find('.' + y.highlighted)
                                                      .hasClass(y.disabled) ||
                                                  (B.set(
                                                      'select',
                                                      B.component.item.highlight
                                                  ),
                                                  x.closeOnSelect &&
                                                      B.close(!0)));
                                  })),
                          B.trigger('open'));
                },
                close: function(a) {
                    return (
                        a &&
                            (x.editable
                                ? f.focus()
                                : (B.$holder.off('focus.toOpen').focus(),
                                  setTimeout(function() {
                                      B.$holder.on('focus.toOpen', t);
                                  }, 0))),
                        z.removeClass(y.active),
                        e(f, 'expanded', !1),
                        setTimeout(function() {
                            B.$root.removeClass(y.opened + ' ' + y.focused),
                                e(B.$root[0], 'hidden', !0);
                        }, 0),
                        w.open
                            ? ((w.open = !1),
                              v &&
                                  k
                                      .css('overflow', '')
                                      .css('padding-right', '-=' + d()),
                              j.off('.' + w.id),
                              B.trigger('close'))
                            : B
                    );
                },
                clear: function(a) {
                    return B.set('clear', null, a);
                },
                set: function(b, c, d) {
                    var e,
                        f,
                        g = a.isPlainObject(b),
                        h = g ? b : {};
                    if (((d = g && a.isPlainObject(c) ? c : d || {}), b)) {
                        g || (h[b] = c);
                        for (e in h)
                            (f = h[e]),
                                e in B.component.item &&
                                    (void 0 === f && (f = null),
                                    B.component.set(e, f, d)),
                                ('select' == e || 'clear' == e) &&
                                    z
                                        .val(
                                            'clear' == e
                                                ? ''
                                                : B.get(e, x.format)
                                        )
                                        .trigger('change');
                        B.render();
                    }
                    return d.muted ? B : B.trigger('set', h);
                },
                get: function(a, c) {
                    if (((a = a || 'value'), null != w[a])) return w[a];
                    if ('valueSubmit' == a) {
                        if (B._hidden) return B._hidden.value;
                        a = 'value';
                    }
                    if ('value' == a) return f.value;
                    if (a in B.component.item) {
                        if ('string' == typeof c) {
                            var d = B.component.get(a);
                            return d
                                ? b._.trigger(
                                      B.component.formats.toString,
                                      B.component,
                                      [c, d]
                                  )
                                : '';
                        }
                        return B.component.get(a);
                    }
                },
                on: function(b, c, d) {
                    var e,
                        f,
                        g = a.isPlainObject(b),
                        h = g ? b : {};
                    if (b) {
                        g || (h[b] = c);
                        for (e in h)
                            (f = h[e]),
                                d && (e = '_' + e),
                                (w.methods[e] = w.methods[e] || []),
                                w.methods[e].push(f);
                    }
                    return B;
                },
                off: function() {
                    var a,
                        b,
                        c = arguments;
                    for (a = 0, namesCount = c.length; a < namesCount; a += 1)
                        (b = c[a]), b in w.methods && delete w.methods[b];
                    return B;
                },
                trigger: function(a, c) {
                    var d = function(a) {
                        var d = w.methods[a];
                        d &&
                            d.map(function(a) {
                                b._.trigger(a, B, [c]);
                            });
                    };
                    return d('_' + a), d(a), B;
                }
            });
        return new A();
    }
    function c(a) {
        var b,
            c = 'position';
        return (
            a.currentStyle
                ? (b = a.currentStyle[c])
                : window.getComputedStyle && (b = getComputedStyle(a)[c]),
            'fixed' == b
        );
    }
    function d() {
        if (k.height() <= i.height()) return 0;
        var b = a('<div style="visibility:hidden;width:100px" />').appendTo(
                'body'
            ),
            c = b[0].offsetWidth;
        b.css('overflow', 'scroll');
        var d = a('<div style="width:100%" />').appendTo(b),
            e = d[0].offsetWidth;
        return b.remove(), c - e;
    }
    function e(b, c, d) {
        if (a.isPlainObject(c)) for (var e in c) f(b, e, c[e]);
        else f(b, c, d);
    }
    function f(a, b, c) {
        a.setAttribute(('role' == b ? '' : 'aria-') + b, c);
    }
    function g(b, c) {
        a.isPlainObject(b) || (b = { attribute: c }), (c = '');
        for (var d in b) {
            var e = ('role' == d ? '' : 'aria-') + d,
                f = b[d];
            c += null == f ? '' : e + '="' + b[d] + '"';
        }
        return c;
    }
    function h() {
        try {
            return document.activeElement;
        } catch (a) {}
    }
    var i = a(window),
        j = a(document),
        k = a(document.documentElement),
        l = null != document.documentElement.style.transition;
    return (
        (b.klasses = function(a) {
            return (
                (a = a || 'picker'),
                {
                    picker: a,
                    opened: a + '--opened',
                    focused: a + '--focused',
                    input: a + '__input',
                    active: a + '__input--active',
                    target: a + '__input--target',
                    holder: a + '__holder',
                    frame: a + '__frame',
                    wrap: a + '__wrap',
                    box: a + '__box'
                }
            );
        }),
        (b._ = {
            group: function(a) {
                for (
                    var c, d = '', e = b._.trigger(a.min, a);
                    e <= b._.trigger(a.max, a, [e]);
                    e += a.i
                )
                    (c = b._.trigger(a.item, a, [e])),
                        (d += b._.node(a.node, c[0], c[1], c[2]));
                return d;
            },
            node: function(b, c, d, e) {
                return c
                    ? ((c = a.isArray(c) ? c.join('') : c),
                      (d = d ? ' class="' + d + '"' : ''),
                      (e = e ? ' ' + e : ''),
                      '<' + b + d + e + '>' + c + '</' + b + '>')
                    : '';
            },
            lead: function(a) {
                return (10 > a ? '0' : '') + a;
            },
            trigger: function(a, b, c) {
                return 'function' == typeof a ? a.apply(b, c || []) : a;
            },
            digits: function(a) {
                return /\d/.test(a[1]) ? 2 : 1;
            },
            isDate: function(a) {
                return (
                    {}.toString.call(a).indexOf('Date') > -1 &&
                    this.isInteger(a.getDate())
                );
            },
            isInteger: function(a) {
                return (
                    {}.toString.call(a).indexOf('Number') > -1 && a % 1 === 0
                );
            },
            ariaAttr: g
        }),
        (b.extend = function(c, d) {
            (a.fn[c] = function(e, f) {
                var g = this.data(c);
                return 'picker' == e
                    ? g
                    : g && 'string' == typeof e
                    ? b._.trigger(g[e], g, [f])
                    : this.each(function() {
                          var f = a(this);
                          f.data(c) || new b(this, c, d, e);
                      });
            }),
                (a.fn[c].defaults = d.defaults);
        }),
        b
    );
});

/*!
 * Date picker for pickadate.js v3.5.6
 * http://amsul.github.io/pickadate.js/date.htm
 */
!(function(a) {
    'function' == typeof define && define.amd
        ? define(['picker', 'jquery'], a)
        : 'object' == typeof exports
        ? (module.exports = a(require('./picker.js'), require('jquery')))
        : a(Picker, jQuery);
})(function(a, b) {
    function c(a, b) {
        var c = this,
            d = a.$node[0],
            e = d.value,
            f = a.$node.data('value'),
            g = f || e,
            h = f ? b.formatSubmit : b.format,
            i = function() {
                return d.currentStyle
                    ? 'rtl' == d.currentStyle.direction
                    : 'rtl' == getComputedStyle(a.$root[0]).direction;
            };
        (c.settings = b),
            (c.$node = a.$node),
            (c.queue = {
                min: 'measure create',
                max: 'measure create',
                now: 'now create',
                select: 'parse create validate',
                highlight: 'parse navigate create validate',
                view: 'parse create validate viewset',
                disable: 'deactivate',
                enable: 'activate'
            }),
            (c.item = {}),
            (c.item.clear = null),
            (c.item.disable = (b.disable || []).slice(0)),
            (c.item.enable = -(function(a) {
                return a[0] === !0 ? a.shift() : -1;
            })(c.item.disable)),
            c
                .set('min', b.min)
                .set('max', b.max)
                .set('now'),
            g
                ? c.set('select', g, { format: h, defaultValue: !0 })
                : c.set('select', null).set('highlight', c.item.now),
            (c.key = {
                40: 7,
                38: -7,
                39: function() {
                    return i() ? -1 : 1;
                },
                37: function() {
                    return i() ? 1 : -1;
                },
                go: function(a) {
                    var b = c.item.highlight,
                        d = new Date(b.year, b.month, b.date + a);
                    c.set('highlight', d, { interval: a }), this.render();
                }
            }),
            a
                .on(
                    'render',
                    function() {
                        a.$root
                            .find('.' + b.klass.selectMonth)
                            .on('change', function() {
                                var c = this.value;
                                c &&
                                    (a.set('highlight', [
                                        a.get('view').year,
                                        c,
                                        a.get('highlight').date
                                    ]),
                                    a.$root
                                        .find('.' + b.klass.selectMonth)
                                        .trigger('focus'));
                            }),
                            a.$root
                                .find('.' + b.klass.selectYear)
                                .on('change', function() {
                                    var c = this.value;
                                    c &&
                                        (a.set('highlight', [
                                            c,
                                            a.get('view').month,
                                            a.get('highlight').date
                                        ]),
                                        a.$root
                                            .find('.' + b.klass.selectYear)
                                            .trigger('focus'));
                                });
                    },
                    1
                )
                .on(
                    'open',
                    function() {
                        var d = '';
                        c.disabled(c.get('now')) &&
                            (d = ':not(.' + b.klass.buttonToday + ')'),
                            a.$root
                                .find('button' + d + ', select')
                                .attr('disabled', !1);
                    },
                    1
                )
                .on(
                    'close',
                    function() {
                        a.$root.find('button, select').attr('disabled', !0);
                    },
                    1
                );
    }
    var d = 7,
        e = 6,
        f = a._;
    (c.prototype.set = function(a, b, c) {
        var d = this,
            e = d.item;
        return null === b
            ? ('clear' == a && (a = 'select'), (e[a] = b), d)
            : ((e[
                  'enable' == a ? 'disable' : 'flip' == a ? 'enable' : a
              ] = d.queue[a]
                  .split(' ')
                  .map(function(e) {
                      return (b = d[e](a, b, c));
                  })
                  .pop()),
              'select' == a
                  ? d.set('highlight', e.select, c)
                  : 'highlight' == a
                  ? d.set('view', e.highlight, c)
                  : a.match(/^(flip|min|max|disable|enable)$/) &&
                    (e.select &&
                        d.disabled(e.select) &&
                        d.set('select', e.select, c),
                    e.highlight &&
                        d.disabled(e.highlight) &&
                        d.set('highlight', e.highlight, c)),
              d);
    }),
        (c.prototype.get = function(a) {
            return this.item[a];
        }),
        (c.prototype.create = function(a, c, d) {
            var e,
                g = this;
            return (
                (c = void 0 === c ? a : c),
                c == -(1 / 0) || c == 1 / 0
                    ? (e = c)
                    : b.isPlainObject(c) && f.isInteger(c.pick)
                    ? (c = c.obj)
                    : b.isArray(c)
                    ? ((c = new Date(c[0], c[1], c[2])),
                      (c = f.isDate(c) ? c : g.create().obj))
                    : (c =
                          f.isInteger(c) || f.isDate(c)
                              ? g.normalize(new Date(c), d)
                              : g.now(a, c, d)),
                {
                    year: e || c.getFullYear(),
                    month: e || c.getMonth(),
                    date: e || c.getDate(),
                    day: e || c.getDay(),
                    obj: e || c,
                    pick: e || c.getTime()
                }
            );
        }),
        (c.prototype.createRange = function(a, c) {
            var d = this,
                e = function(a) {
                    return a === !0 || b.isArray(a) || f.isDate(a)
                        ? d.create(a)
                        : a;
                };
            return (
                f.isInteger(a) || (a = e(a)),
                f.isInteger(c) || (c = e(c)),
                f.isInteger(a) && b.isPlainObject(c)
                    ? (a = [c.year, c.month, c.date + a])
                    : f.isInteger(c) &&
                      b.isPlainObject(a) &&
                      (c = [a.year, a.month, a.date + c]),
                { from: e(a), to: e(c) }
            );
        }),
        (c.prototype.withinRange = function(a, b) {
            return (
                (a = this.createRange(a.from, a.to)),
                b.pick >= a.from.pick && b.pick <= a.to.pick
            );
        }),
        (c.prototype.overlapRanges = function(a, b) {
            var c = this;
            return (
                (a = c.createRange(a.from, a.to)),
                (b = c.createRange(b.from, b.to)),
                c.withinRange(a, b.from) ||
                    c.withinRange(a, b.to) ||
                    c.withinRange(b, a.from) ||
                    c.withinRange(b, a.to)
            );
        }),
        (c.prototype.now = function(a, b, c) {
            return (
                (b = new Date()),
                c && c.rel && b.setDate(b.getDate() + c.rel),
                this.normalize(b, c)
            );
        }),
        (c.prototype.navigate = function(a, c, d) {
            var e,
                f,
                g,
                h,
                i = b.isArray(c),
                j = b.isPlainObject(c),
                k = this.item.view;
            if (i || j) {
                for (
                    j
                        ? ((f = c.year), (g = c.month), (h = c.date))
                        : ((f = +c[0]), (g = +c[1]), (h = +c[2])),
                        d &&
                            d.nav &&
                            k &&
                            k.month !== g &&
                            ((f = k.year), (g = k.month)),
                        e = new Date(f, g + (d && d.nav ? d.nav : 0), 1),
                        f = e.getFullYear(),
                        g = e.getMonth();
                    new Date(f, g, h).getMonth() !== g;

                )
                    h -= 1;
                c = [f, g, h];
            }
            return c;
        }),
        (c.prototype.normalize = function(a) {
            return a.setHours(0, 0, 0, 0), a;
        }),
        (c.prototype.measure = function(a, b) {
            var c = this;
            return (
                b
                    ? 'string' == typeof b
                        ? (b = c.parse(a, b))
                        : f.isInteger(b) && (b = c.now(a, b, { rel: b }))
                    : (b = 'min' == a ? -(1 / 0) : 1 / 0),
                b
            );
        }),
        (c.prototype.viewset = function(a, b) {
            return this.create([b.year, b.month, 1]);
        }),
        (c.prototype.validate = function(a, c, d) {
            var e,
                g,
                h,
                i,
                j = this,
                k = c,
                l = d && d.interval ? d.interval : 1,
                m = -1 === j.item.enable,
                n = j.item.min,
                o = j.item.max,
                p =
                    m &&
                    j.item.disable.filter(function(a) {
                        if (b.isArray(a)) {
                            var d = j.create(a).pick;
                            d < c.pick ? (e = !0) : d > c.pick && (g = !0);
                        }
                        return f.isInteger(a);
                    }).length;
            if (
                (!d || (!d.nav && !d.defaultValue)) &&
                ((!m && j.disabled(c)) ||
                    (m && j.disabled(c) && (p || e || g)) ||
                    (!m && (c.pick <= n.pick || c.pick >= o.pick)))
            )
                for (
                    m && !p && ((!g && l > 0) || (!e && 0 > l)) && (l *= -1);
                    j.disabled(c) &&
                    (Math.abs(l) > 1 &&
                        (c.month < k.month || c.month > k.month) &&
                        ((c = k), (l = l > 0 ? 1 : -1)),
                    c.pick <= n.pick
                        ? ((h = !0),
                          (l = 1),
                          (c = j.create([
                              n.year,
                              n.month,
                              n.date + (c.pick === n.pick ? 0 : -1)
                          ])))
                        : c.pick >= o.pick &&
                          ((i = !0),
                          (l = -1),
                          (c = j.create([
                              o.year,
                              o.month,
                              o.date + (c.pick === o.pick ? 0 : 1)
                          ]))),
                    !h || !i);

                )
                    c = j.create([c.year, c.month, c.date + l]);
            return c;
        }),
        (c.prototype.disabled = function(a) {
            var c = this,
                d = c.item.disable.filter(function(d) {
                    return f.isInteger(d)
                        ? a.day === (c.settings.firstDay ? d : d - 1) % 7
                        : b.isArray(d) || f.isDate(d)
                        ? a.pick === c.create(d).pick
                        : b.isPlainObject(d)
                        ? c.withinRange(d, a)
                        : void 0;
                });
            return (
                (d =
                    d.length &&
                    !d.filter(function(a) {
                        return (
                            (b.isArray(a) && 'inverted' == a[3]) ||
                            (b.isPlainObject(a) && a.inverted)
                        );
                    }).length),
                -1 === c.item.enable
                    ? !d
                    : d || a.pick < c.item.min.pick || a.pick > c.item.max.pick
            );
        }),
        (c.prototype.parse = function(a, b, c) {
            var d = this,
                e = {};
            return b && 'string' == typeof b
                ? ((c && c.format) ||
                      ((c = c || {}), (c.format = d.settings.format)),
                  d.formats.toArray(c.format).map(function(a) {
                      var c = d.formats[a],
                          g = c
                              ? f.trigger(c, d, [b, e])
                              : a.replace(/^!/, '').length;
                      c && (e[a] = b.substr(0, g)), (b = b.substr(g));
                  }),
                  [e.yyyy || e.yy, +(e.mm || e.m) - 1, e.dd || e.d])
                : b;
        }),
        (c.prototype.formats = (function() {
            function a(a, b, c) {
                var d = a.match(/[^\x00-\x7F]+|\w+/)[0];
                return c.mm || c.m || (c.m = b.indexOf(d) + 1), d.length;
            }
            function b(a) {
                return a.match(/\w+/)[0].length;
            }
            return {
                d: function(a, b) {
                    return a ? f.digits(a) : b.date;
                },
                dd: function(a, b) {
                    return a ? 2 : f.lead(b.date);
                },
                ddd: function(a, c) {
                    return a ? b(a) : this.settings.weekdaysShort[c.day];
                },
                dddd: function(a, c) {
                    return a ? b(a) : this.settings.weekdaysFull[c.day];
                },
                m: function(a, b) {
                    return a ? f.digits(a) : b.month + 1;
                },
                mm: function(a, b) {
                    return a ? 2 : f.lead(b.month + 1);
                },
                mmm: function(b, c) {
                    var d = this.settings.monthsShort;
                    return b ? a(b, d, c) : d[c.month];
                },
                mmmm: function(b, c) {
                    var d = this.settings.monthsFull;
                    return b ? a(b, d, c) : d[c.month];
                },
                yy: function(a, b) {
                    return a ? 2 : ('' + b.year).slice(2);
                },
                yyyy: function(a, b) {
                    return a ? 4 : b.year;
                },
                toArray: function(a) {
                    return a.split(/(d{1,4}|m{1,4}|y{4}|yy|!.)/g);
                },
                toString: function(a, b) {
                    var c = this;
                    return c.formats
                        .toArray(a)
                        .map(function(a) {
                            return (
                                f.trigger(c.formats[a], c, [0, b]) ||
                                a.replace(/^!/, '')
                            );
                        })
                        .join('');
                }
            };
        })()),
        (c.prototype.isDateExact = function(a, c) {
            var d = this;
            return (f.isInteger(a) && f.isInteger(c)) ||
                ('boolean' == typeof a && 'boolean' == typeof c)
                ? a === c
                : (f.isDate(a) || b.isArray(a)) && (f.isDate(c) || b.isArray(c))
                ? d.create(a).pick === d.create(c).pick
                : b.isPlainObject(a) && b.isPlainObject(c)
                ? d.isDateExact(a.from, c.from) && d.isDateExact(a.to, c.to)
                : !1;
        }),
        (c.prototype.isDateOverlap = function(a, c) {
            var d = this,
                e = d.settings.firstDay ? 1 : 0;
            return f.isInteger(a) && (f.isDate(c) || b.isArray(c))
                ? ((a = (a % 7) + e), a === d.create(c).day + 1)
                : f.isInteger(c) && (f.isDate(a) || b.isArray(a))
                ? ((c = (c % 7) + e), c === d.create(a).day + 1)
                : b.isPlainObject(a) && b.isPlainObject(c)
                ? d.overlapRanges(a, c)
                : !1;
        }),
        (c.prototype.flipEnable = function(a) {
            var b = this.item;
            b.enable = a || (-1 == b.enable ? 1 : -1);
        }),
        (c.prototype.deactivate = function(a, c) {
            var d = this,
                e = d.item.disable.slice(0);
            return (
                'flip' == c
                    ? d.flipEnable()
                    : c === !1
                    ? (d.flipEnable(1), (e = []))
                    : c === !0
                    ? (d.flipEnable(-1), (e = []))
                    : c.map(function(a) {
                          for (var c, g = 0; g < e.length; g += 1)
                              if (d.isDateExact(a, e[g])) {
                                  c = !0;
                                  break;
                              }
                          c ||
                              ((f.isInteger(a) ||
                                  f.isDate(a) ||
                                  b.isArray(a) ||
                                  (b.isPlainObject(a) && a.from && a.to)) &&
                                  e.push(a));
                      }),
                e
            );
        }),
        (c.prototype.activate = function(a, c) {
            var d = this,
                e = d.item.disable,
                g = e.length;
            return (
                'flip' == c
                    ? d.flipEnable()
                    : c === !0
                    ? (d.flipEnable(1), (e = []))
                    : c === !1
                    ? (d.flipEnable(-1), (e = []))
                    : c.map(function(a) {
                          var c, h, i, j;
                          for (i = 0; g > i; i += 1) {
                              if (((h = e[i]), d.isDateExact(h, a))) {
                                  (c = e[i] = null), (j = !0);
                                  break;
                              }
                              if (d.isDateOverlap(h, a)) {
                                  b.isPlainObject(a)
                                      ? ((a.inverted = !0), (c = a))
                                      : b.isArray(a)
                                      ? ((c = a), c[3] || c.push('inverted'))
                                      : f.isDate(a) &&
                                        (c = [
                                            a.getFullYear(),
                                            a.getMonth(),
                                            a.getDate(),
                                            'inverted'
                                        ]);
                                  break;
                              }
                          }
                          if (c)
                              for (i = 0; g > i; i += 1)
                                  if (d.isDateExact(e[i], a)) {
                                      e[i] = null;
                                      break;
                                  }
                          if (j)
                              for (i = 0; g > i; i += 1)
                                  if (d.isDateOverlap(e[i], a)) {
                                      e[i] = null;
                                      break;
                                  }
                          c && e.push(c);
                      }),
                e.filter(function(a) {
                    return null != a;
                })
            );
        }),
        (c.prototype.nodes = function(a) {
            var b = this,
                c = b.settings,
                g = b.item,
                h = g.now,
                i = g.select,
                j = g.highlight,
                k = g.view,
                l = g.disable,
                m = g.min,
                n = g.max,
                o = (function(a, b) {
                    return (
                        c.firstDay && (a.push(a.shift()), b.push(b.shift())),
                        f.node(
                            'thead',
                            f.node(
                                'tr',
                                f.group({
                                    min: 0,
                                    max: d - 1,
                                    i: 1,
                                    node: 'th',
                                    item: function(d) {
                                        return [
                                            a[d],
                                            c.klass.weekdays,
                                            'scope=col title="' + b[d] + '"'
                                        ];
                                    }
                                })
                            )
                        )
                    );
                })(
                    (c.showWeekdaysFull
                        ? c.weekdaysFull
                        : c.weekdaysShort
                    ).slice(0),
                    c.weekdaysFull.slice(0)
                ),
                p = function(a) {
                    return f.node(
                        'div',
                        ' ',
                        c.klass['nav' + (a ? 'Next' : 'Prev')] +
                            ((a && k.year >= n.year && k.month >= n.month) ||
                            (!a && k.year <= m.year && k.month <= m.month)
                                ? ' ' + c.klass.navDisabled
                                : ''),
                        'data-nav=' +
                            (a || -1) +
                            ' ' +
                            f.ariaAttr({
                                role: 'button',
                                controls: b.$node[0].id + '_table'
                            }) +
                            ' title="' +
                            (a ? c.labelMonthNext : c.labelMonthPrev) +
                            '"'
                    );
                },
                q = function() {
                    var d = c.showMonthsShort ? c.monthsShort : c.monthsFull;
                    return c.selectMonths
                        ? f.node(
                              'select',
                              f.group({
                                  min: 0,
                                  max: 11,
                                  i: 1,
                                  node: 'option',
                                  item: function(a) {
                                      return [
                                          d[a],
                                          0,
                                          'value=' +
                                              a +
                                              (k.month == a
                                                  ? ' selected'
                                                  : '') +
                                              ((k.year == m.year &&
                                                  a < m.month) ||
                                              (k.year == n.year && a > n.month)
                                                  ? ' disabled'
                                                  : '')
                                      ];
                                  }
                              }),
                              c.klass.selectMonth,
                              (a ? '' : 'disabled') +
                                  ' ' +
                                  f.ariaAttr({
                                      controls: b.$node[0].id + '_table'
                                  }) +
                                  ' title="' +
                                  c.labelMonthSelect +
                                  '"'
                          )
                        : f.node('div', d[k.month], c.klass.month);
                },
                r = function() {
                    var d = k.year,
                        e = c.selectYears === !0 ? 5 : ~~(c.selectYears / 2);
                    if (e) {
                        var g = m.year,
                            h = n.year,
                            i = d - e,
                            j = d + e;
                        if ((g > i && ((j += g - i), (i = g)), j > h)) {
                            var l = i - g,
                                o = j - h;
                            (i -= l > o ? o : l), (j = h);
                        }
                        return f.node(
                            'select',
                            f.group({
                                min: i,
                                max: j,
                                i: 1,
                                node: 'option',
                                item: function(a) {
                                    return [
                                        a,
                                        0,
                                        'value=' +
                                            a +
                                            (d == a ? ' selected' : '')
                                    ];
                                }
                            }),
                            c.klass.selectYear,
                            (a ? '' : 'disabled') +
                                ' ' +
                                f.ariaAttr({
                                    controls: b.$node[0].id + '_table'
                                }) +
                                ' title="' +
                                c.labelYearSelect +
                                '"'
                        );
                    }
                    return f.node('div', d, c.klass.year);
                };
            return (
                f.node(
                    'div',
                    (c.selectYears ? r() + q() : q() + r()) + p() + p(1),
                    c.klass.header
                ) +
                f.node(
                    'table',
                    o +
                        f.node(
                            'tbody',
                            f.group({
                                min: 0,
                                max: e - 1,
                                i: 1,
                                node: 'tr',
                                item: function(a) {
                                    var e =
                                        c.firstDay &&
                                        0 === b.create([k.year, k.month, 1]).day
                                            ? -7
                                            : 0;
                                    return [
                                        f.group({
                                            min: d * a - k.day + e + 1,
                                            max: function() {
                                                return this.min + d - 1;
                                            },
                                            i: 1,
                                            node: 'td',
                                            item: function(a) {
                                                a = b.create([
                                                    k.year,
                                                    k.month,
                                                    a + (c.firstDay ? 1 : 0)
                                                ]);
                                                var d = i && i.pick == a.pick,
                                                    e = j && j.pick == a.pick,
                                                    g =
                                                        (l && b.disabled(a)) ||
                                                        a.pick < m.pick ||
                                                        a.pick > n.pick,
                                                    o = f.trigger(
                                                        b.formats.toString,
                                                        b,
                                                        [c.format, a]
                                                    );
                                                return [
                                                    f.node(
                                                        'div',
                                                        a.date,
                                                        (function(b) {
                                                            return (
                                                                b.push(
                                                                    k.month ==
                                                                        a.month
                                                                        ? c
                                                                              .klass
                                                                              .infocus
                                                                        : c
                                                                              .klass
                                                                              .outfocus
                                                                ),
                                                                h.pick ==
                                                                    a.pick &&
                                                                    b.push(
                                                                        c.klass
                                                                            .now
                                                                    ),
                                                                d &&
                                                                    b.push(
                                                                        c.klass
                                                                            .selected
                                                                    ),
                                                                e &&
                                                                    b.push(
                                                                        c.klass
                                                                            .highlighted
                                                                    ),
                                                                g &&
                                                                    b.push(
                                                                        c.klass
                                                                            .disabled
                                                                    ),
                                                                b.join(' ')
                                                            );
                                                        })([c.klass.day]),
                                                        'data-pick=' +
                                                            a.pick +
                                                            ' ' +
                                                            f.ariaAttr({
                                                                role:
                                                                    'gridcell',
                                                                label: o,
                                                                selected:
                                                                    d &&
                                                                    b.$node.val() ===
                                                                        o
                                                                        ? !0
                                                                        : null,
                                                                activedescendant: e
                                                                    ? !0
                                                                    : null,
                                                                disabled: g
                                                                    ? !0
                                                                    : null
                                                            })
                                                    ),
                                                    '',
                                                    f.ariaAttr({
                                                        role: 'presentation'
                                                    })
                                                ];
                                            }
                                        })
                                    ];
                                }
                            })
                        ),
                    c.klass.table,
                    'id="' +
                        b.$node[0].id +
                        '_table" ' +
                        f.ariaAttr({
                            role: 'grid',
                            controls: b.$node[0].id,
                            readonly: !0
                        })
                ) +
                f.node(
                    'div',
                    f.node(
                        'button',
                        c.today,
                        c.klass.buttonToday,
                        'type=button data-pick=' +
                            h.pick +
                            (a && !b.disabled(h) ? '' : ' disabled') +
                            ' ' +
                            f.ariaAttr({ controls: b.$node[0].id })
                    ) +
                        f.node(
                            'button',
                            c.clear,
                            c.klass.buttonClear,
                            'type=button data-clear=1' +
                                (a ? '' : ' disabled') +
                                ' ' +
                                f.ariaAttr({ controls: b.$node[0].id })
                        ) +
                        f.node(
                            'button',
                            c.close,
                            c.klass.buttonClose,
                            'type=button data-close=true ' +
                                (a ? '' : ' disabled') +
                                ' ' +
                                f.ariaAttr({ controls: b.$node[0].id })
                        ),
                    c.klass.footer
                )
            );
        }),
        (c.defaults = (function(a) {
            return {
                labelMonthNext: 'Next month',
                labelMonthPrev: 'Previous month',
                labelMonthSelect: 'Select a month',
                labelYearSelect: 'Select a year',
                monthsFull: [
                    'January',
                    'February',
                    'March',
                    'April',
                    'May',
                    'June',
                    'July',
                    'August',
                    'September',
                    'October',
                    'November',
                    'December'
                ],
                monthsShort: [
                    'Jan',
                    'Feb',
                    'Mar',
                    'Apr',
                    'May',
                    'Jun',
                    'Jul',
                    'Aug',
                    'Sep',
                    'Oct',
                    'Nov',
                    'Dec'
                ],
                weekdaysFull: [
                    'Sunday',
                    'Monday',
                    'Tuesday',
                    'Wednesday',
                    'Thursday',
                    'Friday',
                    'Saturday'
                ],
                weekdaysShort: [
                    'Sun',
                    'Mon',
                    'Tue',
                    'Wed',
                    'Thu',
                    'Fri',
                    'Sat'
                ],
                today: 'Today',
                clear: 'Clear',
                close: 'Close',
                closeOnSelect: !0,
                closeOnClear: !0,
                format: 'd mmmm, yyyy',
                klass: {
                    table: a + 'table',
                    header: a + 'header',
                    navPrev: a + 'nav--prev',
                    navNext: a + 'nav--next',
                    navDisabled: a + 'nav--disabled',
                    month: a + 'month',
                    year: a + 'year',
                    selectMonth: a + 'select--month',
                    selectYear: a + 'select--year',
                    weekdays: a + 'weekday',
                    day: a + 'day',
                    disabled: a + 'day--disabled',
                    selected: a + 'day--selected',
                    highlighted: a + 'day--highlighted',
                    now: a + 'day--today',
                    infocus: a + 'day--infocus',
                    outfocus: a + 'day--outfocus',
                    footer: a + 'footer',
                    buttonClear: a + 'button--clear',
                    buttonToday: a + 'button--today',
                    buttonClose: a + 'button--close'
                }
            };
        })(a.klasses().picker + '__')),
        a.extend('pickadate', c);
});

/*!
 * Time picker for pickadate.js v3.5.6
 * http://amsul.github.io/pickadate.js/time.htm
 */
!(function(a) {
    'function' == typeof define && define.amd
        ? define(['picker', 'jquery'], a)
        : 'object' == typeof exports
        ? (module.exports = a(require('./picker.js'), require('jquery')))
        : a(Picker, jQuery);
})(function(a, b) {
    function c(a, b) {
        var c = this,
            d = a.$node[0].value,
            e = a.$node.data('value'),
            f = e || d,
            g = e ? b.formatSubmit : b.format;
        (c.settings = b),
            (c.$node = a.$node),
            (c.queue = {
                interval: 'i',
                min: 'measure create',
                max: 'measure create',
                now: 'now create',
                select: 'parse create validate',
                highlight: 'parse create validate',
                view: 'parse create validate',
                disable: 'deactivate',
                enable: 'activate'
            }),
            (c.item = {}),
            (c.item.clear = null),
            (c.item.interval = b.interval || 30),
            (c.item.disable = (b.disable || []).slice(0)),
            (c.item.enable = -(function(a) {
                return a[0] === !0 ? a.shift() : -1;
            })(c.item.disable)),
            c
                .set('min', b.min)
                .set('max', b.max)
                .set('now'),
            f
                ? c.set('select', f, { format: g })
                : c.set('select', null).set('highlight', c.item.now),
            (c.key = {
                40: 1,
                38: -1,
                39: 1,
                37: -1,
                go: function(a) {
                    c.set(
                        'highlight',
                        c.item.highlight.pick + a * c.item.interval,
                        { interval: a * c.item.interval }
                    ),
                        this.render();
                }
            }),
            a
                .on(
                    'render',
                    function() {
                        var c = a.$root.children(),
                            d = c.find('.' + b.klass.viewset),
                            e = function(a) {
                                return ['webkit', 'moz', 'ms', 'o', ''].map(
                                    function(b) {
                                        return (b ? '-' + b + '-' : '') + a;
                                    }
                                );
                            },
                            f = function(a, b) {
                                e('transform').map(function(c) {
                                    a.css(c, b);
                                }),
                                    e('transition').map(function(c) {
                                        a.css(c, b);
                                    });
                            };
                        d.length &&
                            (f(c, 'none'),
                            (c[0].scrollTop =
                                ~~d.position().top - 2 * d[0].clientHeight),
                            f(c, ''));
                    },
                    1
                )
                .on(
                    'open',
                    function() {
                        a.$root.find('button').attr('disabled', !1);
                    },
                    1
                )
                .on(
                    'close',
                    function() {
                        a.$root.find('button').attr('disabled', !0);
                    },
                    1
                );
    }
    var d = 24,
        e = 60,
        f = 12,
        g = d * e,
        h = a._;
    (c.prototype.set = function(a, b, c) {
        var d = this,
            e = d.item;
        return null === b
            ? ('clear' == a && (a = 'select'), (e[a] = b), d)
            : ((e[
                  'enable' == a ? 'disable' : 'flip' == a ? 'enable' : a
              ] = d.queue[a]
                  .split(' ')
                  .map(function(e) {
                      return (b = d[e](a, b, c));
                  })
                  .pop()),
              'select' == a
                  ? d.set('highlight', e.select, c)
                  : 'highlight' == a
                  ? d.set('view', e.highlight, c)
                  : 'interval' == a
                  ? d.set('min', e.min, c).set('max', e.max, c)
                  : a.match(/^(flip|min|max|disable|enable)$/) &&
                    (e.select && d.disabled(e.select) && d.set('select', b, c),
                    e.highlight &&
                        d.disabled(e.highlight) &&
                        d.set('highlight', b, c),
                    'min' == a && d.set('max', e.max, c)),
              d);
    }),
        (c.prototype.get = function(a) {
            return this.item[a];
        }),
        (c.prototype.create = function(a, c, f) {
            var i = this;
            return (
                (c = void 0 === c ? a : c),
                h.isDate(c) && (c = [c.getHours(), c.getMinutes()]),
                b.isPlainObject(c) && h.isInteger(c.pick)
                    ? (c = c.pick)
                    : b.isArray(c)
                    ? (c = +c[0] * e + +c[1])
                    : h.isInteger(c) || (c = i.now(a, c, f)),
                'max' == a && c < i.item.min.pick && (c += g),
                'min' != a &&
                    'max' != a &&
                    (c - i.item.min.pick) % i.item.interval !== 0 &&
                    (c += i.item.interval),
                (c = i.normalize(a, c, f)),
                {
                    hour: ~~(d + c / e) % d,
                    mins: (e + (c % e)) % e,
                    time: (g + c) % g,
                    pick: c % g
                }
            );
        }),
        (c.prototype.createRange = function(a, c) {
            var d = this,
                e = function(a) {
                    return a === !0 || b.isArray(a) || h.isDate(a)
                        ? d.create(a)
                        : a;
                };
            return (
                h.isInteger(a) || (a = e(a)),
                h.isInteger(c) || (c = e(c)),
                h.isInteger(a) && b.isPlainObject(c)
                    ? (a = [c.hour, c.mins + a * d.settings.interval])
                    : h.isInteger(c) &&
                      b.isPlainObject(a) &&
                      (c = [a.hour, a.mins + c * d.settings.interval]),
                { from: e(a), to: e(c) }
            );
        }),
        (c.prototype.withinRange = function(a, b) {
            return (
                (a = this.createRange(a.from, a.to)),
                b.pick >= a.from.pick && b.pick <= a.to.pick
            );
        }),
        (c.prototype.overlapRanges = function(a, b) {
            var c = this;
            return (
                (a = c.createRange(a.from, a.to)),
                (b = c.createRange(b.from, b.to)),
                c.withinRange(a, b.from) ||
                    c.withinRange(a, b.to) ||
                    c.withinRange(b, a.from) ||
                    c.withinRange(b, a.to)
            );
        }),
        (c.prototype.now = function(a, b) {
            var c,
                d = this.item.interval,
                f = new Date(),
                g = f.getHours() * e + f.getMinutes(),
                i = h.isInteger(b);
            return (
                (g -= g % d),
                (c = 0 > b && -d >= d * b + g),
                (g += 'min' == a && c ? 0 : d),
                i && (g += d * (c && 'max' != a ? b + 1 : b)),
                g
            );
        }),
        (c.prototype.normalize = function(a, b) {
            var c = this.item.interval,
                d = (this.item.min && this.item.min.pick) || 0;
            return (b -= 'min' == a ? 0 : (b - d) % c);
        }),
        (c.prototype.measure = function(a, c, f) {
            var g = this;
            return (
                c || (c = 'min' == a ? [0, 0] : [d - 1, e - 1]),
                'string' == typeof c
                    ? (c = g.parse(a, c))
                    : c === !0 || h.isInteger(c)
                    ? (c = g.now(a, c, f))
                    : b.isPlainObject(c) &&
                      h.isInteger(c.pick) &&
                      (c = g.normalize(a, c.pick, f)),
                c
            );
        }),
        (c.prototype.validate = function(a, b, c) {
            var d = this,
                e = c && c.interval ? c.interval : d.item.interval;
            return (
                d.disabled(b) && (b = d.shift(b, e)),
                (b = d.scope(b)),
                d.disabled(b) && (b = d.shift(b, -1 * e)),
                b
            );
        }),
        (c.prototype.disabled = function(a) {
            var c = this,
                d = c.item.disable.filter(function(d) {
                    return h.isInteger(d)
                        ? a.hour == d
                        : b.isArray(d) || h.isDate(d)
                        ? a.pick == c.create(d).pick
                        : b.isPlainObject(d)
                        ? c.withinRange(d, a)
                        : void 0;
                });
            return (
                (d =
                    d.length &&
                    !d.filter(function(a) {
                        return (
                            (b.isArray(a) && 'inverted' == a[2]) ||
                            (b.isPlainObject(a) && a.inverted)
                        );
                    }).length),
                -1 === c.item.enable
                    ? !d
                    : d || a.pick < c.item.min.pick || a.pick > c.item.max.pick
            );
        }),
        (c.prototype.shift = function(a, b) {
            var c = this,
                d = c.item.min.pick,
                e = c.item.max.pick;
            for (
                b = b || c.item.interval;
                c.disabled(a) &&
                ((a = c.create((a.pick += b))), !(a.pick <= d || a.pick >= e));

            );
            return a;
        }),
        (c.prototype.scope = function(a) {
            var b = this.item.min.pick,
                c = this.item.max.pick;
            return this.create(a.pick > c ? c : a.pick < b ? b : a);
        }),
        (c.prototype.parse = function(a, b, c) {
            var d,
                f,
                g,
                i,
                j,
                k = this,
                l = {};
            if (!b || 'string' != typeof b) return b;
            (c && c.format) || ((c = c || {}), (c.format = k.settings.format)),
                k.formats.toArray(c.format).map(function(a) {
                    var c,
                        d = k.formats[a],
                        e = d
                            ? h.trigger(d, k, [b, l])
                            : a.replace(/^!/, '').length;
                    d &&
                        ((c = b.substr(0, e)),
                        (l[a] = c.match(/^\d+$/) ? +c : c)),
                        (b = b.substr(e));
                });
            for (i in l)
                (j = l[i]),
                    h.isInteger(j)
                        ? i.match(/^(h|hh)$/i)
                            ? ((d = j), ('h' == i || 'hh' == i) && (d %= 12))
                            : 'i' == i && (f = j)
                        : i.match(/^a$/i) &&
                          j.match(/^p/i) &&
                          ('h' in l || 'hh' in l) &&
                          (g = !0);
            return (g ? d + 12 : d) * e + f;
        }),
        (c.prototype.formats = {
            h: function(a, b) {
                return a ? h.digits(a) : b.hour % f || f;
            },
            hh: function(a, b) {
                return a ? 2 : h.lead(b.hour % f || f);
            },
            H: function(a, b) {
                return a ? h.digits(a) : '' + (b.hour % 24);
            },
            HH: function(a, b) {
                return a ? h.digits(a) : h.lead(b.hour % 24);
            },
            i: function(a, b) {
                return a ? 2 : h.lead(b.mins);
            },
            a: function(a, b) {
                return a ? 4 : g / 2 > b.time % g ? 'a.m.' : 'p.m.';
            },
            A: function(a, b) {
                return a ? 2 : g / 2 > b.time % g ? 'AM' : 'PM';
            },
            toArray: function(a) {
                return a.split(/(h{1,2}|H{1,2}|i|a|A|!.)/g);
            },
            toString: function(a, b) {
                var c = this;
                return c.formats
                    .toArray(a)
                    .map(function(a) {
                        return (
                            h.trigger(c.formats[a], c, [0, b]) ||
                            a.replace(/^!/, '')
                        );
                    })
                    .join('');
            }
        }),
        (c.prototype.isTimeExact = function(a, c) {
            var d = this;
            return (h.isInteger(a) && h.isInteger(c)) ||
                ('boolean' == typeof a && 'boolean' == typeof c)
                ? a === c
                : (h.isDate(a) || b.isArray(a)) && (h.isDate(c) || b.isArray(c))
                ? d.create(a).pick === d.create(c).pick
                : b.isPlainObject(a) && b.isPlainObject(c)
                ? d.isTimeExact(a.from, c.from) && d.isTimeExact(a.to, c.to)
                : !1;
        }),
        (c.prototype.isTimeOverlap = function(a, c) {
            var d = this;
            return h.isInteger(a) && (h.isDate(c) || b.isArray(c))
                ? a === d.create(c).hour
                : h.isInteger(c) && (h.isDate(a) || b.isArray(a))
                ? c === d.create(a).hour
                : b.isPlainObject(a) && b.isPlainObject(c)
                ? d.overlapRanges(a, c)
                : !1;
        }),
        (c.prototype.flipEnable = function(a) {
            var b = this.item;
            b.enable = a || (-1 == b.enable ? 1 : -1);
        }),
        (c.prototype.deactivate = function(a, c) {
            var d = this,
                e = d.item.disable.slice(0);
            return (
                'flip' == c
                    ? d.flipEnable()
                    : c === !1
                    ? (d.flipEnable(1), (e = []))
                    : c === !0
                    ? (d.flipEnable(-1), (e = []))
                    : c.map(function(a) {
                          for (var c, f = 0; f < e.length; f += 1)
                              if (d.isTimeExact(a, e[f])) {
                                  c = !0;
                                  break;
                              }
                          c ||
                              ((h.isInteger(a) ||
                                  h.isDate(a) ||
                                  b.isArray(a) ||
                                  (b.isPlainObject(a) && a.from && a.to)) &&
                                  e.push(a));
                      }),
                e
            );
        }),
        (c.prototype.activate = function(a, c) {
            var d = this,
                e = d.item.disable,
                f = e.length;
            return (
                'flip' == c
                    ? d.flipEnable()
                    : c === !0
                    ? (d.flipEnable(1), (e = []))
                    : c === !1
                    ? (d.flipEnable(-1), (e = []))
                    : c.map(function(a) {
                          var c, g, i, j;
                          for (i = 0; f > i; i += 1) {
                              if (((g = e[i]), d.isTimeExact(g, a))) {
                                  (c = e[i] = null), (j = !0);
                                  break;
                              }
                              if (d.isTimeOverlap(g, a)) {
                                  b.isPlainObject(a)
                                      ? ((a.inverted = !0), (c = a))
                                      : b.isArray(a)
                                      ? ((c = a), c[2] || c.push('inverted'))
                                      : h.isDate(a) &&
                                        (c = [
                                            a.getFullYear(),
                                            a.getMonth(),
                                            a.getDate(),
                                            'inverted'
                                        ]);
                                  break;
                              }
                          }
                          if (c)
                              for (i = 0; f > i; i += 1)
                                  if (d.isTimeExact(e[i], a)) {
                                      e[i] = null;
                                      break;
                                  }
                          if (j)
                              for (i = 0; f > i; i += 1)
                                  if (d.isTimeOverlap(e[i], a)) {
                                      e[i] = null;
                                      break;
                                  }
                          c && e.push(c);
                      }),
                e.filter(function(a) {
                    return null != a;
                })
            );
        }),
        (c.prototype.i = function(a, b) {
            return h.isInteger(b) && b > 0 ? b : this.item.interval;
        }),
        (c.prototype.nodes = function(a) {
            var b = this,
                c = b.settings,
                d = b.item.select,
                e = b.item.highlight,
                f = b.item.view,
                g = b.item.disable;
            return h.node(
                'ul',
                h.group({
                    min: b.item.min.pick,
                    max: b.item.max.pick,
                    i: b.item.interval,
                    node: 'li',
                    item: function(a) {
                        a = b.create(a);
                        var i = a.pick,
                            j = d && d.pick == i,
                            k = e && e.pick == i,
                            l = g && b.disabled(a),
                            m = h.trigger(b.formats.toString, b, [c.format, a]);
                        return [
                            h.trigger(b.formats.toString, b, [
                                h.trigger(c.formatLabel, b, [a]) || c.format,
                                a
                            ]),
                            (function(a) {
                                return (
                                    j && a.push(c.klass.selected),
                                    k && a.push(c.klass.highlighted),
                                    f && f.pick == i && a.push(c.klass.viewset),
                                    l && a.push(c.klass.disabled),
                                    a.join(' ')
                                );
                            })([c.klass.listItem]),
                            'data-pick=' +
                                a.pick +
                                ' ' +
                                h.ariaAttr({
                                    role: 'option',
                                    label: m,
                                    selected:
                                        j && b.$node.val() === m ? !0 : null,
                                    activedescendant: k ? !0 : null,
                                    disabled: l ? !0 : null
                                })
                        ];
                    }
                }) +
                    h.node(
                        'li',
                        h.node(
                            'button',
                            c.clear,
                            c.klass.buttonClear,
                            'type=button data-clear=1' +
                                (a ? '' : ' disabled') +
                                ' ' +
                                h.ariaAttr({ controls: b.$node[0].id })
                        ),
                        '',
                        h.ariaAttr({ role: 'presentation' })
                    ),
                c.klass.list,
                h.ariaAttr({ role: 'listbox', controls: b.$node[0].id })
            );
        }),
        (c.defaults = (function(a) {
            return {
                clear: 'Clear',
                format: 'h:i A',
                interval: 30,
                closeOnSelect: !0,
                closeOnClear: !0,
                klass: {
                    picker: a + ' ' + a + '--time',
                    holder: a + '__holder',
                    list: a + '__list',
                    listItem: a + '__list-item',
                    disabled: a + '__list-item--disabled',
                    selected: a + '__list-item--selected',
                    highlighted: a + '__list-item--highlighted',
                    viewset: a + '__list-item--viewset',
                    now: a + '__list-item--now',
                    buttonClear: a + '__button--clear'
                }
            };
        })(a.klasses().picker)),
        a.extend('pickatime', c);
});



// WEBPACK FOOTER //
// ./packages/OSB/js/plugins/pickajquery.js